import React, { Component } from 'react';

import CardForm from './CardForm';
import EVoucherNotifForm from './EVoucherNotifForm';
import MenuForm from './MenuForm';
import ShowsNotifForm from './ShowsNotifForm';
import StringForm from './StringForm';

export default class FormContainer extends Component {
	render() {
		let {
			actions,

			formType,
		} = this.props;

		const defaultProps = {
			actions,
		};

		switch (formType.toUpperCase()) {
			case 'EVOUCHER_NOTIF':
				return <EVoucherNotifForm {...defaultProps} />;
				break;
			case 'SHOWS_NOTIF':
				return <ShowsNotifForm {...defaultProps} />;
				break;
			case 'MENU':
				return <MenuForm {...defaultProps} />;
				break;
			case 'CARD':
				return <CardForm {...defaultProps} />;
				break;
			case 'STRING':
				return <StringForm {...defaultProps} />;
				break;
			default:
				return '';
				break;
		}
	}

	componentWillUnmount() {
		let { actions } = this.props;

		actions.setValue({
			showModal: false,
			isLoadingAction: false,

			formType: '',
			formTitle: '',

			evoucherNotif_dailyAM: '',
			evoucherNotif_dailyPM: '',

			showsNotif_form_dailyNotif_hh: '',
			showsNotif_form_dailyNotif_mm: '',
			showsNotif_form_dailyNotif_ss: '',

			menu_form_isTierPointsEnabled: false,
			menu_form_isGVEnabled: false,
			menu_form_isCalypsoEnabled: false,

			card_form_isQRCodeEnabled: false,
		});
	}
}



// WEBPACK FOOTER //
// ./components/AppConfig/FormContainer/index.js